import React, {Component} from "react";
import Header from "../../components/Header";
import {Grid, Typography} from "@material-ui/core";
import {primaryColor, webFont} from "../../config/theme";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ScrollToTopOnMount from "../../ScrollToTopOnMount";
import {Link} from "react-router-dom";

class Terms extends Component {
  constructor() {
    super();
  }

  render() {
    return(
      <div>
        <ScrollToTopOnMount>
          <Header history={this.props.history} />
          <Grid container spacing={20} style={{marginTop:65}}>
            <div className="dish-container-custom">
              <Grid item md={12} style={{margin: '0px auto', maxWidth: 1140}}>
                <Grid container style={{textAlign:'left'}}>
                  <Grid item md={12} xs={12}>
                    <Typography style={{ ...styles.setFont,...styles.setColor, fontSize: 24, fontWeight: 500 }} >
                      About Us
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container style={{paddingTop:20}} >
                  <Grid item md={12} >
                    <Typography style={{ ...styles.setFont, fontSize: 14 }} >
                      <p>Cuisine Crafters was created out of a need, a personal need that resonated with many that we spoke with about it.</p>
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container style={{paddingTop:20}} >

                  <Grid item xs={12}>
                    <Typography style={{ ...styles.setFont, fontSize: 14 }} >
                      <p>With life becoming increasingly busy with the advent of mobile devices that enabled work to continue after leaving the office, or as in the case of the current pandemic, a never ending work day and balancing that with kids that are studying from home, a better solution is needed as to how food is made.</p>
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container style={{paddingTop:20}} >
                  <Grid item xs={12}>
                    <Typography style={{ ...styles.setFont, fontSize: 14 }} >
                      <p>Whether you are a family of two working adults with kids, or a single parent with kids or a busy single professional, you just like us, have been exasperated at what to cook and how often to cook. This is no longer a problem with Cuisine Crafters. Hire your own personal chef or cook to help you cook for a weeknight or a weekend dinner or lunch or cook for a whole week!</p>
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container style={{paddingTop:20}} >
                  <Grid item xs={12}>
                    <Typography style={{ ...styles.setFont, fontSize: 14 }} >
                      <p>Have a dinner date? How about having it at home with a Chef or cook creating the meal for you?</p>
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container style={{paddingTop:20}} >
                  <Grid item xs={12}>
                    <Typography style={{ ...styles.setFont, fontSize: 14 }} >
                      <p>Have a birthday to celebrate, or an anniversary or a party of any kind and need freshly made food? Hire your own Chef for the event.</p>
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container style={{paddingTop:20}} >
                  <Grid item xs={12}>
                    <Typography style={{ ...styles.setFont, fontSize: 14 }} >
                      <p>We are here to help you find a chef or a cook that works great for you. You can try as many chefs or cooks as you like and there is no commitment to a specific chef or cook. <Link to={"/?signUp=yes"} style={{ color: '#ff8000' }}>Click here</Link> to join at no cost.</p>
                    </Typography>
                  </Grid>

                </Grid>
                <Grid container style={{paddingTop:20}} >
                  <Grid item xs={12}>
                    <Typography style={{ ...styles.setFont, fontSize: 14 }} >
                      <p>Cuisine Crafters was also created to serve the needs of Culinary professionals who have been impacted by the pandemic, with the largest ever closing of restaurants in the United States and other nations, a different avenue is needed and Cuisine Crafters aims to provide that for you.</p>
                    </Typography>
                  </Grid>

                </Grid>
                <Grid container style={{paddingTop:20}} >
                  <Grid item xs={12}>
                    <Typography style={{ ...styles.setFont, fontSize: 14 }} >
                      <p>Come join us and support us and help build the world's largest network of culinary professionals that can connect with individuals and families to serve them one on one. This is hospitality reimagined for a new era.</p>
                    </Typography>
                  </Grid>

                </Grid>
                <Grid container style={{paddingTop:20}} >
                  <Grid item xs={12}>
                    <Typography style={{ ...styles.setFont, fontSize: 14 }} >
                      <p><Link to={"/?signUp=yes&chef=yes"} style={{ color: '#ff8000' }}>Click here</Link> to sign up as a valued Culinary Service Provider.</p>
                    </Typography>
                  </Grid>

                </Grid>
                <Grid container style={{paddingTop:20, paddingBottom: 50}} >
                  <Grid item xs={12}>
                    <Typography style={{ ...styles.setFont, fontSize: 14 }} >
                      <p>We will bring smiles to the world, one personalized dining engagement at a time.</p>
                    </Typography>
                  </Grid>

                </Grid>
              </Grid>
            </div>
          </Grid>
        </ScrollToTopOnMount>
      </div>
    )
  }
}

export default Terms;

const styles = {
  setFont: {
    fontFamily: webFont
  },
  setColor: {
    color: primaryColor
  },
  tBorder:{
    border: "1px solid black"
  }
};
